<template>
  <v-container fluid grid-list-xl class="pa-0">
    <v-row v-if="showLeadSupplierSelection">
      <v-col cols="4">
        <v-select
          v-model="product"
          label="Product"
          item-text="title"
          item-value="value"
          :items="products"
          variant="underlined"
          color="primary"
        ></v-select>
      </v-col>
      <v-spacer />
    </v-row>
    <v-row>
      <overview-broker-score @toolTip="showToolTip" />
      <overview-sales-funnel :product.sync="product" @toolTip="showToolTip" />
      <overview-overall-totals :product.sync="product" @toolTip="showToolTip" />
      <overview-agent-leaderboard @toolTip="showToolTip" />
      <overview-overdue-referrals @toolTip="showToolTip" />
      <overview-performance :product.sync="product" @toolTip="showToolTip" />
      <overview-referral-summary
        :product.sync="product"
        @toolTip="showToolTip"
      />
      <overview-leads-limit
        v-if="showLeadSupplierWidgets"
        :is-call-to-action-widget="showCTA"
        @toolTip="showToolTip"
      />
      <overview-referral-progression
        v-if="showLeadSupplierWidgets"
        :is-call-to-action-widget="showCTA"
        @toolTip="showToolTip"
      />

      <overview-leads-by-status
        v-if="showLeadSupplierWidgets"
        :is-call-to-action-widget="showCTA"
        @toolTip="showToolTip"
      />
      <overview-leads-by-source
        v-if="showLeadSupplierWidgets"
        :is-call-to-action-widget="showCTA"
        @toolTip="showToolTip"
      />
    </v-row>

    <component
      :is="toolTip"
      :dialog.sync="toolTipDialog"
      @close="hideToolTip"
      @update:dialog="toolTipDialog = $event"
    />
  </v-container>
</template>

<script>
import OverviewAgentLeaderboard from "@/components/console/dashboard/OverviewAgentLeaderboard";
import OverviewSalesFunnel from "@/components/console/dashboard/OverviewSalesFunnel";
import OverviewOverallTotals from "@/components/console/dashboard/OverviewOverallTotals";
import OverviewPerformance from "@/components/console/dashboard/OverviewPerformance";
import OverviewReferralSummary from "@/components/console/dashboard/OverviewReferralSummary";
import OverviewOverdueReferrals from "@/components/console/dashboard/OverviewOverdueReferrals";
import OverviewLeadsByStatus from "@/components/console/dashboard/OverviewLeadsByStatus";
import OverviewLeadsBySource from "@/components/console/dashboard/OverviewLeadsBySource";
import OverviewReferralProgression from "@/components/console/dashboard/OverviewReferralProgression";
import OverviewLeadsLimit from "@/components/console/dashboard/OverviewLeadsLimit";
import { mapGetters } from "vuex";
import OverviewBrokerScore from "@/components/console/dashboard/OverviewBrokerScore";
import { defineAsyncComponent, markRaw } from "vue";

export default {
  name: "console-overview",
  components: {
    OverviewBrokerScore,
    OverviewAgentLeaderboard,
    OverviewSalesFunnel,
    OverviewOverallTotals,
    OverviewPerformance,
    OverviewReferralSummary,
    OverviewOverdueReferrals,
    OverviewLeadsByStatus,
    OverviewLeadsBySource,
    OverviewReferralProgression,
    OverviewLeadsLimit,
  },
  computed: {
    ...mapGetters("user", [
      "isAdmin",
      "isLeadSupplier",
      "isBrokerAdmin",
      "brokerageHasProduct",
    ]),
    ...mapGetters("auth", ["impBrokerageHasProduct"]),

    showLeadSupplierSelection() {
      return this.isAdmin || this.isLeadSupplier;
    },
    // dont show: if you're (LS or Admin) and this.product === PRIMESTREET
    showLeadSupplierWidgets() {
      return !(
        (this.isAdmin || this.isLeadSupplier) &&
        this.product === "PRIMESTREET"
      );
    },
    showCTA() {
      // Determine if widgets should be blurred for marketing based on brokerage products
      // Check if user is broker-admin -> check their brokerage products
      // else check impersonated brokerages products
      return !(this.isBrokerAdmin
        ? this.brokerageHasProduct("LeadGenius")
        : this.impBrokerageHasProduct("LeadGenius"));
    },
  },
  data() {
    return {
      product: "COMBINED",
      products: [
        { title: "PrimeStreet Referrals + IRIS", value: "COMBINED" },
        { title: "PrimeStreet Referrals", value: "PRIMESTREET" },
        { title: "IRIS", value: "LEAD_GENIUS" },
      ],
      toolTip: null,
      toolTipDialog: false,
    };
  },
  methods: {
    showToolTip(comp) {
      // this.toolTip = defineAsyncComponent(() => import(`./${comp}`));
      const tooltipComp = defineAsyncComponent(() => import(`./${comp}`));
      this.toolTip = markRaw(tooltipComp);
      this.toolTipDialog = true;
      // this.toolTip = comp
    },
    hideToolTip() {
      this.toolTipDialog = false;
      this.toolTip = null;
    },
  },
};
</script>

<style>
.full-height .flex {
  display: flex;
}

.full-height .flex > .card {
  flex: 1 1 auto;
}
.v-toolbar__lesspad .v-toolbar__content {
  padding: 0 16px;
}
.funnel-count {
  width: 80%;
}
</style>
